<template>
    <router-link to="/language" class="language-picker" :class="{disabled: disabled}">
        <icon icon="globe"></icon>
        <span class="title">{{$store.state.config.lang}}</span>
    </router-link>
</template>

<script>

export default {

    props: {
        disabled: {
            type: Boolean,
            default: false,
        }
    }

}

</script>

<style lang="scss" scoped >

    @import "../scss/includes.scss";

    a{
        color: white;
        text-decoration: none;
        display: flex;
        align-items: center;
        justify-content: center;

        &.disabled{
            opacity: 0.5;
            pointer-events: none;
        }

    }

    a .icon{
        font-size: 25px;
    }

    span{
        display: block;
        text-transform: uppercase;
        font-weight: 600;
        font-size: 13px;
        margin-left: 5px;
        line-height: 1em;
    }

</style>